import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import {
  Box,
  Center,
  Divider,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { GiHamburgerMenu } from "react-icons/gi";

const DiscoverIcon = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <div
      style={{
        position: "sticky",
        width: "100%",
        paddingLeft: 20,
        paddingRight: 20,
        marginBottom: 35,
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        paddingTop: 10,
        zIndex: 99,
        ...(colorMode === "light"
          ? {
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }
          : {
              backgroundColor: "black",
            }),
      }}
    >
      <Flex
        maxW={680}
        mx="auto"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          onClick={toggleColorMode}
          mb={0}
          p="4"
          ml={0}
          display="flex"
          alignItems="center"
          cursor="pointer"
        >
          {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
        </Box>
        <Spacer />
        <Box p="4" ml={0} mr={3} display="flex" alignItems="center" height={70}>
          <Link href={`/`}>
            {colorMode === "dark" && (
              <Image
                src="/SC Icon_B_White.svg"
                width={25}
                height={100}
                alt="Discover more Songcards"
              />
            )}
            {colorMode === "light" && (
              <Image
                src="/SC Icon_B_Black.svg"
                width={25}
                height={100}
                alt="Discover more Songcards"
              />
            )}
          </Link>
        </Box>
        <Spacer />
        <Menu>
          <Box mt={0}>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<GiHamburgerMenu size={20} />}
              variant="outline"
              borderWidth={0}
              _focus={{ outline: "none", boxShadow: "none" }}
              _active={{ bg: "transparent" }}
              _hover={{ bg: "transparent" }}
            />
          </Box>
          <MenuList backgroundColor={colorMode === "light" ? "white" : "black"}>
            <Link href={"/info"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">What is a Songcard?</Text>
              </MenuItem>
            </Link>
            <Link href={"https://artists.songcards.io/"} target="_blank">
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">Artist Portal</Text>
              </MenuItem>
            </Link>
            <Link href={"/blog/christopher-carvalho"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">About</Text>
              </MenuItem>
            </Link>
            <Link href={"/blog"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">Blog</Text>
              </MenuItem>
            </Link>
            <Link href={"/search"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">Search</Text>
              </MenuItem>
            </Link>
            <Link href={"/terms"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">Terms</Text>
              </MenuItem>
            </Link>
            <Link href={"/get-app"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">App</Text>
              </MenuItem>
            </Link>
            <Link href={"/links"}>
              <MenuItem
                backgroundColor={colorMode === "light" ? "white" : "black"}
              >
                <Text fontSize="sm">more...</Text>
              </MenuItem>
            </Link>
          </MenuList>
        </Menu>
      </Flex>
      <Center>
        <Divider mt={2} mb={0} maxW={680} />
      </Center>
    </div>
  );
};

export default DiscoverIcon;
